module.exports = __webpack_public_path__ + "media/application/images/2018/header-lock-4cdccf826e39ce63b5dec5605101d08c.svg";